module.exports = __webpack_public_path__ + "static/media/abbiamo2.8ea5e05f.png";